(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('ApAvananAddBlacklistModalController', ["$q", "$scope", "$modalInstance", "$rootScope", "$timeout", "options", "apAvananExceptionsDao", "tablePaginationHelper", "defaultListConverter", "modals", function ($q, $scope, $modalInstance, $rootScope, $timeout, options, apAvananExceptionsDao, tablePaginationHelper, defaultListConverter, modals) {
        $scope.loading = true;
        $scope.error = '';
        $scope.params = [];
        $scope.loaded = false;
        function simpleTooltipConverter(text) {
            return '#' + JSON.stringify({
                display: 'text',
                text: text,
                tooltip: {
                    content: { text: text },
                    position: {
                        my: 'bottom center',
                        at: 'top center'
                    },
                    style: {
                        classes: 'qtip-standard ap-avanan-blacklist-tip',
                        def: false
                    }
                }
            });
        }
        var locationChangeUnsubscribe = $rootScope.$on('$locationChangeStart', function () {
            $modalInstance.dismiss();
        });
        $scope.$on('$destroy', function () {
            locationChangeUnsubscribe();
        });
        $scope.ok = function () {
            if ($scope.loading) {
                return;
            }
            if ($scope.totalEmails) {
                return modals.confirm({
                    title: 'Caution',
                    message: 'Marking emails as phishing triggers your policies.<br/>' + 'In case any active policy for phishing is running - it will affect the following ' + $scope.totalEmails + ' emails.<br/>' + '<strong>Are you sure you want to continue?</strong>',
                    okText: 'Yes',
                    cancelText: 'No'
                }).then(function () {
                    $scope.loading = true;
                    apAvananExceptionsDao.blacklistCreate(makeFilters()).then(function () {
                        $modalInstance.close();
                    }, function (error) {
                        if (error.status >= 400 && error.status < 500 && error.data && error.data.message) {
                            $scope.error = error.data.message;
                        } else {
                            $scope.error = 'Error creating Block-List rule';
                        }
                        $scope.loading = false;
                    });
                });
            }
            $scope.loading = true;
            apAvananExceptionsDao.blacklistCreate(makeFilters()).then(function () {
                $modalInstance.close();
            }, function (error) {
                if (error.status >= 400 && error.status < 500 && error.data && error.data.message) {
                    $scope.error = error.data.message;
                } else {
                    $scope.error = 'Error creating Block-List rule';
                }
                $scope.loading = false;
            });
        };
        $scope.close = function () {
            $modalInstance.dismiss();
        };
        function genVariant(str, arr) {
            if (str.indexOf('.') !== -1) {
                var subStr = str.slice(str.indexOf('.') + 1);
                if (subStr.indexOf('.') !== -1) {
                    arr.push({
                        id: '.' + subStr,
                        label: '@*.' + subStr
                    });
                    genVariant(subStr, arr);
                }
            }
        }
        if (options.entityType && options.entityId) {
            $scope.title = 'Mark emails as phishing';
            $scope.titleExplanation = 'The selected emails as well as any future emails that meet all of the criteria below will be handled as phishing-emails';
            apAvananExceptionsDao.blacklistOptions(options.entityType, options.entityId).then(function (response) {
                $scope.params = _(response.data).chain().map(function (val, key) {
                    if (key === 'sender_domain_suffix' && val.value) {
                        var variants = [{
                                id: val.value,
                                label: '@' + val.value
                            }];
                        genVariant(val.value, variants);
                        return {
                            id: key,
                            label: val.label,
                            variants: variants,
                            type: 'selector',
                            order: val.order,
                            enabled: false
                        };
                    }
                    return {
                        id: key,
                        label: val.label,
                        data: val.value,
                        type: 'string',
                        order: val.order,
                        enabled: true
                    };
                }).sortBy('order').value();
                $scope.options.columns = standardColumns.concat(_($scope.params).chain().reject(function (param) {
                    return param.id === 'sender_domain_suffix';
                }).map(function (param) {
                    return {
                        id: param.id,
                        text: param.label,
                        converter: simpleTooltipConverter
                    };
                }).value());
                $scope.loading = false;
                $scope.loaded = true;
            }, function (error) {
                $scope.loading = false;
                $scope.error = 'This email can not be Block-Listed';
            });
        } else if (options.blacklistId) {
            $scope.mode = 'rule';
            $scope.title = 'Block-List Item';
            apAvananExceptionsDao.blacklistItem(options.blacklistId).then(function (response) {
                if (!response.data.labels) {
                    return;
                }
                $scope.params = _(response.data.blacklist).chain().map(function (val, key) {
                    if (_(val).isNull() || !response.data.labels[key]) {
                        return;
                    }
                    return {
                        id: key,
                        label: response.data.labels[key].label,
                        data: val,
                        type: 'string',
                        order: response.data.labels[key].order,
                        enabled: false
                    };
                }).compact().sortBy('order').value();
                $scope.options.columns = standardColumns.concat(_(response.data.labels).chain().map(function (val, key) {
                    return {
                        id: key,
                        text: val.label,
                        converter: simpleTooltipConverter
                    };
                }).sortBy('order').value());
                $scope.loading = false;
                $scope.loaded = true;
                $timeout(initTable);
            }, function (error) {
                $scope.loading = false;
                $scope.error = 'Item not found';
            });
        }
        var queryFilters = null;
        var refreshDelay = null;
        function makeFilters() {
            var newData = _($scope.params).chain().map(function (param) {
                if (param.enabled && param.data) {
                    return [
                        param.id,
                        param.data
                    ];
                }
            }).compact().object().value();
            if (options.scanStatus === 'clean' && _(newData).isObject()) {
                newData.status = 'phishing';
                newData.confident = 'medium';
            } else if ((options.scanStatus === 'suspicious' || options.scanStatus === 'phishing') && _(newData).isObject()) {
                newData.status = 'clean';
                newData.confident = 'medium';
            }
            return newData;
        }
        function refreshTable() {
            if ($scope.tableHelper) {
                $scope.tableHelper.reload();
            } else {
                initTable();
            }
        }
        function scheduleFiltersRefresh() {
            if ($scope.mode === 'rule') {
                return;
            }
            var filters = makeFilters();
            if (refreshDelay) {
                $timeout.cancel(refreshDelay);
                refreshDelay = null;
            }
            if (!$scope.loaded) {
                return;
            }
            if (!angular.equals(filters, queryFilters)) {
                refreshDelay = $timeout(refreshTable, 400);
            }
        }
        var standardColumns = [
            {
                id: 'entity_id',
                hidden: true
            },
            {
                id: 'entity_type',
                hidden: true
            },
            {
                id: 'received_at',
                text: 'Received',
                format: 'time'
            },
            {
                id: 'recipients',
                text: 'Recipients',
                converter: 'listConverter',
                converterArgs: {
                    elementAsTooltip: true,
                    moreInPopup: true,
                    expanded: 10,
                    collapseRest: true,
                    countPostfix: 'recipients'
                }
            }
        ];
        $scope.options = {
            columns: [],
            'options': {
                'defaultOrdering': {
                    'columnName': 'time',
                    'order': 'desc'
                },
                'checkboxes': false
            }
        };
        $scope.tableOptions = {
            disableTop: true,
            orderDisplayMode: 'highlight-column',
            asDivs: true,
            infinite: true,
            reloadUuid: true,
            showWorkingIndicator: true,
            workingIndicatorDisableGui: false,
            pagesAround: 2,
            pagination: {
                pageSize: 20,
                ordering: {}
            },
            dropdownHeader: true
        };
        $scope.okLabel = function () {
            if ($scope.error || $scope.mode === 'rule') {
                return '';
            }
            if (!$scope.tableModel || $scope.tableOptions.loading) {
                return 'Create phishing rule';
            }
            if ($scope.totalEmails) {
                $scope.okTip = 'Mark matching emails (as well as future once) as phishing';
                return 'Create Block-List rule';
            }
            return 'Create phishing rule that does\'t match any existing email';
        };
        $scope.$watch('params', function () {
            _($scope.params).each(function (param) {
                param.readOnly = !param.enabled;
            });
            scheduleFiltersRefresh();
        }, true);
        function initTable() {
            $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                queryFilters = makeFilters();
                var q;
                if ($scope.mode === 'rule') {
                    q = apAvananExceptionsDao.blacklistItem(options.blacklistId);
                } else {
                    q = apAvananExceptionsDao.blacklistMatching(queryFilters);
                }
                $scope.error = '';
                return q.pagination(args.offset, args.limit).converter(defaultListConverter, { columns: $scope.options.columns }).onRequestFail(function (error) {
                    if (error.status === 400 && error.data && error.data.message) {
                        $scope.error = error.data.message;
                        return $q.when({
                            data: {
                                rows: [],
                                total_rows: 0
                            }
                        });
                    } else {
                        return $q.reject(error);
                    }
                });
            }, function (tableModel) {
                $scope.tableModel = tableModel;
                $scope.totalEmails = $scope.tableHelper.getTotal();
            });
        }
    }]);
    m.factory('apAvananAddBlacklistModal', ["$modal", "path", function ($modal, path) {
        return {
            show: function (options) {
                var modalInstance = $modal.open({
                    templateUrl: path('configuration').ctrl('ap-avanan-add-blacklist-modal').template(),
                    controller: 'ApAvananAddBlacklistModalController',
                    size: 'lg',
                    backdrop: _(options).isObject() && !_(options.backdrop).isUndefined() ? options.backdrop : true,
                    keyboard: _(options).isObject() && !_(options.keyboard).isUndefined() ? options.keyboard : true,
                    resolve: { options: _.constant(options) },
                    windowClass: 'ap-avanan-add-blacklist-modal-window'
                });
                return modalInstance.result;
            }
        };
    }]);
}());